// Libraries
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

// MUI
import { SxProps, Theme, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

// Core
import { IFormValidator } from '../../../core/FormValidator';
import { ResourceTextApplication } from '../../../core/resources';

// Common
import { AInputItem, ARadioButtons } from '../../../common/inputs';

// Interfaces
import { IFarmQuestion, IProductionPlan } from '../../../interfaces/IProductionPlan';
import Question from './Question/Question';

// Store
// API
// Feature

interface IEndingOfProductionProps {
    data: IFarmQuestion;
    setData: (q: IFarmQuestion) => void;
    readonly: boolean;
    validator: IFormValidator;
    currentTargetYear: number;
}

export default function EndingOfProduction(props: IEndingOfProductionProps) {
    const { data, setData, readonly, validator, currentTargetYear } = props;
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaCattleProductionPlan']);

    const gridContainerStyles: SxProps<Theme> | undefined = {
        paddingLeft: '40px',
        paddingBottom: '40px',
    };

    const getQuestion = (question: IFarmQuestion, error?: boolean, required?: boolean) => {
        return (
            <Question
                question={question}
                setQuestion={(question) => setData(question)}
                validator={validator}
                readonly={readonly}
                error={error}
                required={required}
            />
        );
    }

    return (
        <Grid container direction='row' style={{ paddingLeft: 40 }} sx={gridContainerStyles}>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                <Typography variant='h4'>{t('AnelmaCattleProductionPlan:1080')}</Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                {getQuestion(data)}
            </Grid>
        </Grid>
    );
}
